import Store from './beedle.js';
import actions from './actions.js';
import mutations from './mutations.js';
import initialState from './state.js';

export default new Store({
  actions,
  mutations,
  initialState,
});
